<template>
  <div>
    <div class="banner">
      <img
        src="https://firebasestorage.googleapis.com/v0/b/foxfox-honda.appspot.com/o/LOGO_VGxLIA-01.png?alt=media&token=ad128f7b-1718-4830-8534-c06999f9e338"
        style="height:120px !important;">
    </div>
    <div class="tile is-parent">
      <article class="tile is-child notification is-danger history_tile">
        <div class="content">
          <div class="tile">
            <div class="tile is-vertical ">
              <h1 class="title is-4">นัดหมายเข้ารับบริการ</h1>
              <section class="hero has-background-light is-fullheight" v-show="!registerSuccess">
                <div class="hero-body-custom">
                  <div class="container">
                    <div class="columns is-centered">
                      <div class="column is-5-tablet is-4-desktop is-3-widescreen">
                        <div class="container"><br>
                          <p v-if="errors.length">
                            <ul>
                              <li v-for="error in errors" v-bind:key="error" class="has-text-danger">{{ error }}</li>
                            </ul><br>
                          </p>

                          <div class="field">
                            <label class="label" v-bind:class="{ 'has-text-danger': errors.name }"><span class="has-text-danger">*</span> ชื่อ-นามสกุล</label>
                            <div class="control">
                              <input class="input" type="text" placeholder="ชื่อ-นามสกุล" v-model="form.name">
                            </div>
                          </div>
                          <div class="field" v-show="carListReady && carList.length > 0">
                            <label class="label" v-bind:class="{ 'has-text-danger': errors.licenseNo }"><span class="has-text-danger">*</span> เลือกเลขทะเบียนรถ</label>
                            <div class="select">
                              <select placeholder="เลือกเลขทะเบียนรถ" v-model="carSelect" v-on:change="selectCar">
                                <option v-for="car in carList" v-bind:key="car.id" :value="car.licenseNo" >{{car.licenseNo}}</option>
                                <option value="other">เลขทะเบียนอื่น</option>
                              </select>
                            </div>
                          </div>
                          <div class="field" v-show="!carListReady || carList.length <= 0 || carSelect === 'other'">
                            <label class="label" v-bind:class="{ 'has-text-danger': errors.licenseNo }"><span class="has-text-danger">*</span> เลขทะเบียนรถ</label>
                            <div class="control">
                              <input class="input" type="text" placeholder="เลขทะเบียนรถ" v-model="form.licenseNo">
                            </div>
                          </div>
                          <div class="field">
                            <label class="label" v-bind:class="{ 'has-text-danger': errors.tel }"><span class="has-text-danger">*</span> เบอร์โทร</label>
                            <div class="control">
                              <input class="input" type="text" placeholder="เบอร์โทร" v-model="form.tel">
                            </div>
                          </div>
                          <div class="field">
                            <label class="label" v-bind:class="{ 'has-text-danger': errors.branchCode }"><span class="has-text-danger">*</span> สาขาที่เข้ารับบริการ</label>
                              <div class="select">
                                  <select v-model="form.branchCode">
                                    <option v-for="row in branch" v-bind:key="row.id + Math.random()" :value="row.id">{{row.name}}</option>
                                  </select>
                              </div>
                          </div>
                          <div class="field">
                            <label class="label" v-bind:class="{ 'has-text-danger': errors.serviceType }"><span class="has-text-danger">*</span> ประเภทบริการ</label>
                            <div class="select">
                                <select v-model="form.serviceType">
                                  <option v-for="row in serviceType" v-bind:key="row + Math.random()" :value="row">{{row}}</option>
                                </select>
                            </div>
                          </div>
                          <div class="field">
                            <label class="label">ต้องการบริการอื่นๆ</label>
                            <div class="control">
                              <input class="input" type="text" placeholder="ต้องการบริการอื่นๆ" v-model="form.serviceOther">
                            </div>
                          </div>
                          <div class="field">
                            <label class="label" v-bind:class="{ 'has-text-danger': errors.appointmentDate }"><span class="has-text-danger">*</span> วันที่ต้องการเข้ารับบริการ</label>
                            <div class="control">
                              <datepicker v-model="form.appointmentDate" :language="languages[language]" input-class="inputDate"></datepicker>
                            </div>
                          </div>
                          <div class="field">
                            <label class="label" v-bind:class="{ 'has-text-danger': errors.appointmentTime }"><span class="has-text-danger">*</span> เวลาที่ต้องการเข้ารับบริการ</label>
                            <div class="select">
                                <select v-model="form.appointmentTime">
                                  <option v-for="row in appointmentTime" v-bind:key="row + Math.random()" :value="row">{{row}}</option>
                                </select>
                            </div>
                          </div>
                          <div class="field">
                            <label class="label">ข้อมูลเพิ่มเติมที่สะดวกให้ตรวจสอบ<br>หรือ บริการเป็นพิเศษ</label>
                            <div class="control">
                              <textarea class="textarea" placeholder="ข้อมูลเพิ่มเติม หรือ บริการพิเศษ" v-model="form.extra"></textarea>
                            </div>
                          </div>
                          <br>
                          <button class="button is-danger" v-show="!saving" v-on:click="submitCarInfo">ลงทะเบียน</button>
                          <span v-show="saving">กำลังบันทึกข้อมูล...</span>
                          <br><br>
                        </div>
                      </div>
                    </div>
                  </div>
                 </div>
              </section>
            </div>
          </div>
        </div>
      </article>
      <div class="notification" v-show="registerSuccess">
        <b class="has-text-success">ลงทะเบียนเรียบร้อยแล้ว</b><br><br>
        เจ้าหน้าที่จะติดต่อกลับไป<br>เพื่อยืนยันการนัดหมาย<br><br>
        ขอบคุณที่ไว้วางใจ วี.กรุ๊ป ตลอด 20 ปี<br><br>
        <button class="button is-success is-light" v-on:click="closeWindow">x ปิดหน้าต่างนี้</button>
      </div>
    </div>
  </div>
</template>
<style>
.hero-body-custom {
  display: flex;
  padding: 0 !important;
}
.banner {
  text-align: center;
  background-color: #000;
}
input[type=checkbox] {
  padding: 10px;
          transform: scale(2);

  -webkit-transform: scale(2); /* Safari and Chrome */
     -moz-transform: scale(2); /* FF */
  /* Double-sized Checkboxes */
      -ms-transform: scale(2); /* IE */
       -o-transform: scale(2); /* Opera */
}

/* Might want to wrap a span around your checkbox text */
.checkboxtext {
  display: inline;
  /* Checkbox text */
  font-size: 110%;
}
.inputDate {
  width: 100% !important;
  height: 2.25em;
  padding-top: calc(.375em - 1px);
  padding-right: calc(.625em - 1px);
  padding-bottom: calc(.375em - 1px);
  padding-left: calc(.625em - 1px);
  color: #363636;
  font-size: inherit;
  background-color: #fff;
  border: 1px solid transparent;
  border-color: #dbdbdb;
  border-radius: 4px;
}
</style>
<style scoped>
    .title {
      color: #ffffff;
    }
    button.is-danger {
      color:#ffffff;
    }
    .select, select {
      width:100%;
    }
    .is-danger {
        background-color: #ee0000;
        color:#000000;
    }
    .container {
        width: 85%
    }
    .history_tile {
        padding: 1.25rem 1.25rem 1.25rem 1.25rem;
    }
</style>
<script>
import Datepicker from 'vuejs-datepicker/dist/vuejs-datepicker.esm.js'
import * as lang from 'vuejs-datepicker/src/locale'

export default {
  name: 'Booking',
  beforeCreate () {
  },
  components: {
    Datepicker
  },
  data: () => ({
    registerSuccess: false,
    inputdate: '',
    format: 'd MMMM yyyy',
    language: 'th',
    languages: lang,
    branch: [],
    serviceType: [
      'เช็กระยะทั่วไป',
      'ซ่อมทั่วไป',
      'พ่นฆ่าเชื้อภายในรถยนต์',
      'เคลือบสีพ่นกันสนิม',
      'ซ่อมตัวถังและสี'
    ],
    appointmentTime: [
      '7:00 น.',
      '8:00 น.',
      '9:00 น.',
      '10:00 น.',
      '11:00 น.',
      '12:00 น.',
      '13:00 น.',
      '14:00 น.',
      '15:00 น.',
      '16:00 น.',
      '17:00 น.',
      '18:00 น.',
      '19:00 น.'
    ],
    errors: {
      name: false,
      licenseNo: false,
      tel: false,
      branchCode: false,
      serviceType: false,
      appointmentDate: false,
      appointmentTime: false
    },
    profile: {
      userId: '',
      displayName: '',
      pictureUrl: '',
      statusMessage: ''
    },
    form: {
      name: '',
      licenseNo: '',
      tel: '',
      branchCode: '',
      serviceType: '',
      serviceOther: '',
      appointmentDate: '',
      appointmentTime: '',
      extra: '',
      userId: ''
    },
    saving: false,
    eid: '',
    cid: '',
    campaign: '',
    carSelect: null,
    carList: [],
    carListReady: false
  }),
  async mounted () {
    // await this.$liff.init({ liffId: this.$liffId_Appointment }, function (data) {})
    // await this.checkLiffLogin()
    this.branch = this.$branchList
    const queryString = decodeURIComponent(decodeURIComponent(window.location.search).replace('?liff.state=', ''))
    const params = new URLSearchParams(queryString)
    // const code = params.get('code')
    this.eid = params.get('eid')
    this.cid = params.get('cid')
    this.campaign = params.get('campaign')
    if (params.get('code')) {
      // this.form.extra = code
    }

    // if (process.env.NODE_ENV === 'development') {
    //   await this.getProfile_dev()
    // } else {
    //   await this.getProfile()
    // }
    await this.getCarList()
  },
  methods: {
    async checkLiffLogin () {
      await this.$liff.ready.then(async () => {
        if (process.env.NODE_ENV === 'development') {
          this.getProfile_dev()
        } else {
          if (!this.$liff.isLoggedIn()) {
            this.$liff.login()
          } else {
            await this.getProfile()
          }
        }
      })
    },
    async getCarList () {
      let _this = this
      if (_this.profile.userId !== '') {
        _this.carList = []
        await this.$axios
          .get(`${this.$apiUrl}getCarUser?userId=${_this.profile.userId}`)
          .then(async (response) => {
            const result = response.data
            let carExist = []
            await result.forEach((car) => {
              if (typeof carExist[car.licenseNo] === 'undefined') {
                this.form.name = car.customerName
                _this.carList.push(car)
                carExist[car.licenseNo] = car
              }
            })
          })
      }
      _this.carListReady = true
    },
    selectCar () {
      if (this.carSelect && this.carSelect !== 'other') {
        this.form.licenseNo = this.carSelect
      }
    },
    checkForm (e) {
      let _this = this
      let result = true

      for (let field in _this.errors) {
        this.errors[field] = false
        if (!_this.form[field]) {
          result = false
          this.errors[field] = true
        }
      }
      e.preventDefault()
      return result
    },
    submitCarInfo (e) {
      let _this = this
      if (!_this.checkForm(e)) {
        alert('กรุณากรอกข้อมูลให้ครบถ้วน')
        return false
      }
      _this.saving = true
      _this.form.userId = _this.profile.userId
      let params = {
        form: _this.form,
        cid: _this.cid,
        eid: _this.eid,
        campaign: this.campaign
      }
      this.$axios
        .post(`${this.$apiUrl}saveAppointment`, params)
        .then(response => {
          _this.registerSuccess = true
        })
    },
    openWindow () {
      this.$liff.openWindow({
        url: 'https://developers.line.me/en/docs/liff/overview/'
      })
    },
    closeWindow () {
      this.$liff.closeWindow()
    },
    sendMessage () {
      let _this = this
      this.$liff.sendMessages([
        {
          type: 'text',
          text: 'You/\'ve successfully sent a message! Hooray!'
        },
        {
          type: 'sticker',
          packageId: '2',
          stickerId: '144'
        }
      ]).then(function () {
        _this.closeWindow()
        console.log('Message sent')
      }).catch(function (error) {
        console.log('Error sending message: ' + error)
      })
    },
    async getProfile () {
      let _this = this
      await this.$liff.getProfile().then(function (profile) {
        _this.profile = profile
      }).catch(function (error) {
        console.log('Error getting profile: ' + error)
      })
    },
    getProfile_dev () {
      this.profile = {
        'displayName': 'Pamorn Trivorrarat',
        'pictureUrl': 'https://profile.line-scdn.net/0hehdTyqPSOkdZLRSQHV5FEGVoNCouAzwPIUl2JX4pNnQnSHsUMRx8dCgoNCUmTS1BMRhzKHQpMyN9',
        'statusMessage': 'ใช้ไลน์อันนี้นะคร้าบ',
        'userId': 'U691b2080970333bbeb4930dadc6618b6'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Booking.vue